export default __webpack_public_path__ + "../staticImages/sprite-gogreen_mini-2x.png";